import { BrandCaptionLowerThirdEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUnUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUnUseRequestDTO.validationSchema(),
    BrandCaptionLowerThirdEntity
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdUnUseRequest) {
    JsonSchemaValidator.assert(
      RoomBrandCaptionLowerThirdUnUseRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "caption"],
      properties: {
        roomId,
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdUnUseRequest {
  roomId: RoomId;
  caption: BrandCaptionLowerThirdEntity;
}
